import { useRequiredResponseCountsQuery } from '~/requests/projects/useRequiredResponseCounts';
import { Label } from 'semantic-ui-react';
import Link from '~/components/Link';
import { Project } from '~/types/project';
import '../../styles.scss';

interface MessagesProps {
  project: Project
  investorId: string;
  awaitingBid?: boolean;
}

const MessagesButton = ({
  project,
  investorId,
  awaitingBid,
}: MessagesProps) => {
  const { data: requiredResponseCountsData } = useRequiredResponseCountsQuery();
  const requiredResponseCount = requiredResponseCountsData?.find((row: any) => row.investorId === investorId)?.count ?? 0;

  return (
    <div className='messages-container' >
      <Link 
        to={`/project/${project?.id}/messages${investorId? `?investorId=${investorId}` : ''}`} 
        noUnderline
        color = {awaitingBid ? 'var(--color-pure-white)' : 'default'}
      >
        View messages
      </Link>
      {requiredResponseCount ?  (
        <Label circular color='red'>
          {requiredResponseCount}
        </Label>
      ) : null}
    </div>
  );
};

export default MessagesButton;